module.exports = __webpack_public_path__ + "static/img/25.c1e6558d.png";